import * as React from 'react'
import logo from 'images/logo.png'

interface Props {
  title: string
}

const Component: React.FC<Props> = ({ title }) => (
  <>
    <header className="header-large">
      <img loading="lazy" src={logo} alt="Logo" className="header-logo-large" />
    </header>
    <h1 style={{ margin: '40px 0 70px 0' }}>{title}</h1>
  </>
)

export default Component
